import React from 'react';
import styled from 'styled-components';
import { bool, func } from 'prop-types';


export const StyledBurger = styled.button`
  position: absolute;
  top: 5%;
  left: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 40;
  &:focus {
    outline: none;
  }
  div {
    width: 2rem;
    height: 0.25rem;
    background: #242424;
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;
    @media (max-width: 400px){
        width: 1.5rem;
        height: 0.18rem;
    }

  }
  @media (min-width: 900px){
    display: none; 
 }
 @media (max-height: 540px){
    display: flex; 
}
  
`;

export const Burger = ({open, setOpen}) => {
    Burger.propTypes={
        open: bool.isRequired,
        setOpen: func.isRequired,
    };
    
    return (
        <StyledBurger open={open} onClick={() => setOpen(!open)}>
            <div/>
            <div/>
            <div/>
        </StyledBurger>
    )
}



// export default Burger;